
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ExplorerIcon',
  props: {
    type: { type: String, required: true },
    width: { type: Number, default: 20 },
    height: { type: Number, default: 20 },
  },
  computed: {
    path(): string {
      switch (this.type) {
        case 'filter':
          return 'M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5';
        case 'reset':
          return 'M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99';
        case 'info':
          return 'M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z';
        case 'down':
          return 'M19.5 8.25l-7.5 7.5-7.5-7.5';
        case 'up':
          return 'M4.5 15.75l7.5-7.5 7.5 7.5';
        default:
          return '';
      }
    },
  },
});
